"use client";
import { useEffect, useState } from "react";

const useDetectIOS = (): boolean => {
    const [isIOS, setIsIOS] = useState(false);

    useEffect(() => {
        const userAgent = window.navigator.userAgent;
        const detectedIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
        setIsIOS(detectedIOS);
    }, []);

    return isIOS;
};

const ViewportMetaUpdater = () => {
    const isIOS = useDetectIOS();

    useEffect(() => {
        const content = isIOS
            ? "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0"
            : "width=device-width, initial-scale=1, maximum-scale=2.0";

        let meta: any = document.querySelector('meta[name="viewport"]');
        if (!meta) {
            meta = document.createElement("meta");
            meta.name = "viewport";
            document.head.appendChild(meta);
        }
        meta.setAttribute("content", content);
    }, [isIOS]);

    return null;
};

export default ViewportMetaUpdater;
